import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { Dictionary } from "src/app/store/models/common_types";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ReportingPagesService } from "../reporting-pages.service";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import { CommonModalService } from "../../shared/common-modal/common-modal.service";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import {
  nextPageData,
  sortChange,
  filterData,
  reloadGrid,
  getHeight,
} from "../util";
import { VAIconRegistryService, file } from "@va/core-library/icons";
import { CustomGridComponent } from "@va/core-library/custom-grid";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef } from "ng-zorro-antd/modal";
@Component({
  selector: "app-reporting-allbrokers",
  templateUrl: "./reporting-allbrokers.component.html",
  styleUrls: ["./reporting-allbrokers.component.scss"],
  host: { class: "allBroker-page-component" },
})
export class ReportingAllbrokersComponent {
  showSearch = false;
  showGridFilters: boolean;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
  };
  @ViewChild(CustomGridComponent)
  customGridComp: CustomGridComponent;
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  storeSub: Subscription;
  legacyUrl: string;
  dataObservable: Observable<any | any>;
  pageIndex = 1;
  totalResultCount: number;
  appliedFilter: {};
  sortObj: Dictionary<any>;
  pageSize = 24;
  pageSizeOptions = [12, 24, 48, 96];
  sortOrder?: string = "asc";
  globalSearchVal = "";
  initialParams: {};
  data: Array<any> = [];
  errorMsg = "Something went wrong!";
  isLoading = false;
  gridHeight;
  skeletonRows = 20;
  skeletonCol = 5;

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private message: NzMessageService,
    private router: Router,
    private service: ReportingPagesService,
    private dataService: ReportingPagesDataService,
    private modalService: CommonModalService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
    };
    this.legacyUrl = `${window.caUrl}/`;
    this.storeSub = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (data.isSellside) {
          console.error("Could not find breadcrumb dictionary");
          this.message.error(`Error: You do not have access to this page`, {
            nzDuration: 2000,
          });
          setTimeout(() => {
            this.router.navigateByUrl("/home");
          }, 2000);
        }
        this.exportKey = data.isInternal ? "BROKERS" : "";
      });
    this.iconRegistry.registerIcons([file]);
  }
  ngOnInit() {
    this.route.params.subscribe(() => {
      this.page = "allbrokers";
      this.gridUrl = "api/get_all_broker_list?is_companypage=false&";
      const columnFields = [
        { renderer: "link", field: "name" },
        { renderer: "", field: "total" },
        { renderer: "", field: "vaconsensus" },
        { renderer: "", field: "isentitled" },
        { renderer: "multi-icon", field: "disclosure" },
      ];
      const columnsData = [
        [
          {
            children: 1,
            header: "Broker name",
            sortKey: "name",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "No. of Company Models Available",
            sortKey: "total",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "No. of Companies in VA Consensus",
            sortKey: "vaconsensus",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Entitlement Status",
            sortKey: "isentitled",
            showSort: true,
            showFilter: true,
            filterType: "select",
            filterSelectValues: [
              { val: "", display: "[all]" },
              { val: "entitled", display: "Entitled" },
              { val: "not entitled", display: "Not Entitled" },
            ],
            currentValue: "",
          },
          {
            children: 1,
            header: "Disclosures",
            sortKey: "disclosure",
            showSort: false,
            showFilter: false,
          },
        ],
      ];
      this.sortKey = "name";
      this.columns.columnFields = columnFields;
      this.columns.columnsData = columnsData;
      this.columns.widthConfig = ["auto", "25%", "20%", "20%", "20%"];
      this.exportColumns = columnsData[0].map((d) => {
        return d.sortKey;
      });
    });
    this.service.logUserOnRedirection("ALL_BROKER_PAGE", { VALUE: "" });
    this.totalResultCount = 0;
    this.appliedFilter = {};
    this.sortObj = {
      key: this.sortKey,
      value: this.sortOrder !== undefined ? this.sortOrder : "asc",
    };
    const params = {
      baseUrl: this.gridUrl,
      pageIndex: this.pageIndex,
      sortOrder: this.sortObj.value,
      sortKey: this.sortObj.key,
      pageSize: this.pageSize,
      page: this.page,
      filters: [],
      globalSearch: this.globalSearchVal,
    };
    this.initialParams = { ...params };
    this.dataObservable = this.dataService.getReportGridData(params);
  }

  onDataResolved(response) {
    if (response.status === "error") {
      this.totalResultCount = 0;
      if (response.not_entitled) {
        this.showDeleteAlertModal();
      }
    } else {
      this.data = response.rows.map((row) => {
        const disclosureArr = [];
        if (row.disclosure_list) {
          row.disclosure_list.forEach((element) => {
            let disclosureUrl = element.url ? element.url : "";
            if (!disclosureUrl.includes("http")) {
              //SELLSIDE-1666
              if (disclosureUrl.charAt(0) === "/") {
                disclosureUrl = disclosureUrl.slice(1);
              }
              disclosureUrl = this.legacyUrl + disclosureUrl;
            }
            disclosureArr.push({
              linkText: "",
              icon: "file",
              show: true,
              title: element ? element.name : "",
              clickData: {
                link: disclosureUrl,
              },
              clickCallback: this.disclosureClick,
              className: "file-icon",
            });
          });
        }
        let vaconsensus = row.vaconsensus;
        if (row.vaconsensus === -1) {
          vaconsensus = "Not Entitled";
        } else if (row.vaconsensus === -2) {
          vaconsensus = "Not Participating";
        }
        let total = row.total;
        if (row.total === -1) {
          total = "Not Entitled";
        } else if (row.total === -2) {
          total = "Not Participating";
        }

        const rowObj = {
          name: {
            target: "",
            url:
              row.isentitled.toLowerCase() === "entitled"
                ? `/reporting/broker/${row.shortname}`
                : "",
            tooltipText: "",
            displayText: row.name,
            name: row.shortname,
          },
          total: total,
          vaconsensus: vaconsensus,
          isentitled: row.isentitled,
          disclosure: disclosureArr,
        };

        return rowObj;
      });
      this.totalResultCount = response.records;
    }
    this.gridHeight = getHeight.call(this);
  }

  disclosureClick(data) {
    window.open(data.link);
  }

  getNextPageData([pageIndex, pageSize]) {
    this.data = [];
    nextPageData.call(this, pageIndex, pageSize);
  }

  onSortChange([sortData]) {
    this.data = [];
    sortChange.call(this, sortData);
  }

  filterApplied([value, columnData]) {
    this.data = [];
    filterData.call(this, value, columnData);
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
    this.gridHeight = getHeight.call(this);
  }

  onReloadGrid() {
    this.data = [];
    reloadGrid.call(this);
  }

  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }

  handleFailure(err) {
    if (err && err[0] && err[0].not_entitled) {
      this.showDeleteAlertModal();
    }
  }

  showDeleteAlertModal = (): void => {
    const title = `Not Entitled`;
    const message = `<b>
        You are currently not entitled to this content.<br/>
      </b>
      Questions? Contact 
      <a href="mailto:support@visiblealpha.com">support@visiblealpha.com</a>
    `;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ff4e33",
      icon: faExclamationTriangle as IconDefinition,
      actionPrimaryText: "Close",
      onPrimaryClick: primaryAction,
    };

    modal = this.modalService.create(modalOptions);

    modal.afterClose.subscribe(() => {
      this.router.navigateByUrl("/home");
    });
  };
}
